import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
/** Consistent, mobile-first section wrapper: no horizontal overflow, padded, centered. */
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <section id={id} className={`w-full px-4 py-12 sm:py-16 ${className}`} data-id="element-181">
      <div className="mx-auto w-full max-w-3xl" data-id="element-182">{children}</div>
    </section>;
}
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.5,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-183">
      {children}
    </motion.div>;
}
interface SectionTitleProps {
  children: React.ReactNode;
  className?: string;
}
export function SectionTitle({
  children,
  className = ''
}: SectionTitleProps) {
  return <h2 className={`font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-purpleDark sm:text-4xl ${className}`} data-id="element-184">
      {children}
    </h2>;
}